import { commentItems } from '@/mocks/homepage';

export default function Comments() {
  return (
    <section id="comments" className="w-full py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-2 mb-8 md:mb-10">
          <i className="ri-chat-smile-2-line text-xl text-primary-500"></i>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-900 font-heading">
            观众热评
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {commentItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/60 rounded-xl p-5 md:p-6 hover:border-primary-200 transition-all duration-300"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center shrink-0">
                  <span className="text-sm font-bold text-primary-600">{item.avatar}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-400">{item.time}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {item.content}
              </p>
              <div className="flex items-center gap-4">
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-thumb-up-line"></i>
                  <span>{item.likes}</span>
                </button>
                <button className="flex items-center gap-1.5 text-xs text-foreground-400 hover:text-primary-500 transition-colors cursor-pointer">
                  <i className="ri-chat-1-line"></i>
                  <span>回复</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}